
import {createRouter} from "vue-router"
import {createWebHashHistory,createWebHistory} from "vue-router"
 
// const helloWorld = () => import("../components/HelloWorld")
// const index = () => import("../page/index")

const routes = [
    {
      path: "/",
      name: "index",
      component: () => import("../page/index")
    },
  ]
 const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_HISTORY_URL),
    // mode: 'history',
    // base:'/wecom/',
    routes
  })
// const router =  new VueRouter({
//   mode: 'hash', // history
//   routes:[
//     {
//         //主页
//         path:"/",
//         component:home
//     },
//   ]
// })	//返回实例


export default router